import React from 'react'
import './styles.css'

const TextArea = ({
  label,
  placeholder,
  value,
  onChange,
  name,
  error,
  rows = 3,
  limit = 140,
  ...props
}) => {
  return (
    <div className="text-input-container">
      {label && <label className="text-input-label">{label}</label>}
      <textarea
        className={`text-input-field ${error ? 'error' : ''}`}
        placeholder={placeholder}
        value={value || ''}
        onChange={onChange}
        name={name}
        rows={rows}
        maxLength={limit}
        {...props}
      />
      {limit && (
        <div className="text-input-limit">
          {(value && value.length) || 0}/{limit}
        </div>
      )}
      {error && <div className="text-input-error">{error}</div>}
    </div>
  )
}

export default TextArea
